import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsZoomIn = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M17.8553658,17.1621685h0.0000019c1.6950054-1.8563242,2.6255054-4.2480354,2.6255054-6.7543058
			c0-1.3513279-0.2641869-2.6652493-0.7878857-3.9020181c-0.5049953-1.1946874-1.2274189-2.2654629-2.1485672-3.18661
			c-0.9211483-0.9211483-1.9942608-1.6435719-3.1866093-2.148566c-1.2391071-0.5236988-2.5530291-0.7878855-3.904357-0.7878855
			c-1.3583422,0-2.6746011,0.2641868-3.9113712,0.7878855C5.3473969,1.6756628,4.2766213,2.3980863,3.355473,3.3192346
			c-0.9188094,0.9211471-1.6388956,1.9919226-2.1438899,3.18661c-0.52136,1.2344313-0.7855468,2.5483527-0.7855468,3.8996806
			s0.2641867,2.6652508,0.7855468,3.899682c0.5026567,1.1946859,1.2250804,2.2678003,2.1438899,3.1866102
			c0.9188094,0.9211483,1.9919238,1.6435699,3.1866097,2.1485653c1.2367702,0.5236988,2.5530291,0.7878857,3.9113712,0.7878857
			c2.4548349,0,4.7997875-0.8884163,6.6280546-2.5015945l5.6905422,5.6905422l0.8019123-0.7668419L17.8553658,17.1621685z
			 M10.4277382,19.3341122c-4.9096704,0-8.9028692-4.0048885-8.9028692-8.9262495
			c0.0023373-4.92136,4.007226-8.9262486,8.928586-8.9262486s8.9262486,4.0048885,8.9262486,8.9262486
			S15.3631258,19.3341122,10.4277382,19.3341122z"
        />
        <polygon
          points="10.9280567,4.8973417 9.9531355,4.8973417 9.9531355,9.9332619 4.9172173,9.9332619 
			4.9172173,10.9081821 9.9531355,10.9081821 9.9531355,15.9464397 10.9280567,15.9464397 10.9280567,10.9081821 
			15.9663143,10.9081821 15.9663143,9.9332619 10.9280567,9.9332619 		"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsZoomIn;
